import classnames from 'clsx';
import { FormattedMessage } from 'react-intl';

import { Pill } from '../pill';
import style from './beta-tag.module.css';
import { FlexRow } from '../flex';
import { messages } from './messages';

/**
 * @deprecated Use `Badge` from `@mantine/core` instead.
 * See: ui-components/readme-documentation/MIGRATION.md
 */
export const BetaTag = () => {
  return (
    <FlexRow className={classnames(style.container)}>
      <Pill className={classnames(style['beta-pill'])} label={<FormattedMessage {...messages.beta} />} />
    </FlexRow>
  );
};
